<template>
  <form ref="form" v-kendo-validator="!readOnly" novalidate>
    <div class="class">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Name</label>
            <k-input
              :name="'Tenant Name'"
              class="w-100 rounded-border"
              :required="true"
              v-model="tenant.name"
              :disabled="readOnly"
            />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Tenant Contact Name</label>
            <k-input
              :name="'Tenant Contact Person'"
              class="w-100 rounded-border"
              :required="true"
              v-model="tenant.contactPerson"
              :disabled="readOnly"
            />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Tenant Contact No</label>
            <k-input
              :name="'Tenant Contact No'"
              type="text"
              class="w-100 rounded-border"
              :required="true"
              v-model="tenant.contactNo"
              :pattern="'^[0-9]{10}$'"
              :disabled="readOnly"
            />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Tenant Contact Email</label>
            <k-input
              :name="'Contact Email'"
              class="w-100 rounded-border"
              type="email"
              pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$"
              :required="true"
              v-model="tenant.emailId"
              :disabled="readOnly"
            />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Sub Domain Name</label>
            <k-input
              :name="'Sub Domain Name '"
              class="w-100 rounded-border"
              :required="true"
              v-model="tenant.subDomain"
              :disabled="readOnly"
            />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Website</label>
            <k-input
              :name="'Website'"
              class="w-100 rounded-border"
              :required="true"
              v-model="tenant.website"
              :disabled="readOnly"
            />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Client</label>
            <kendo-dropdownlist
              class="w-100 rounded-border"
              v-model="tenant.clientId"
              :data-source="getClient"
              :name="'Client'"
              :data-item-key="'id'"
              :data-text-field="'name'"
              :required="true"
              :option-label="'Select'"
              :data-value-field="'id'"
              :value-primitive="true"            
            ></kendo-dropdownlist>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Latitude</label>
            <k-input
              :name="'Latitude'"
              class="w-100 rounded-border"
              type="text"
              :required="true"
              pattern="^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$"
              v-model="tenant.latitude"
              :disabled="readOnly"
            />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label class="required-field">Longitude</label>
            <k-input
              :name="'Longitude'"
              class="w-100 rounded-border"
              type="text"
              :required="true"
              pattern= "^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$"
              v-model="tenant.longitude"
              :disabled="readOnly"
            />
          </div>
        </div>

      </div>

      
    </div>
    <div class="buttons text-right">
        <!-- <button type="button" class="save-button btn btn-primary ml-3 rounded-border"  @click="save">Save</button>
        <button type="button" style="color: #0047b2;" class="save-button btn ml-3 rounded-border" @click="activate">Save & Activate</button>
        <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3" @click="close">Cancel</button> -->
      </div>
  </form>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { createNamespacedHelpers } from "vuex";
import { notifyApiError, notify } from "../../utils/notification-helper";

const { mapState, mapActions,mapMutations } = createNamespacedHelpers("onboarding");
export default {
 data: function(){
   return {
     
   }
  },
  methods: {
    ...mapActions(["addTenant", "resetDB","activateTenantDtls"]),
    ...mapMutations([]),
    save: function() {
      if (!this.kendoValidator.validate()) {
        return this.$emit("can-continue", { value: false });
      }
      // let data = {
      //   id: "",
      //   tenant: {
      //     id: "",
      //     name: this.tenant.name,
      //     clientId: this.clientId,
      //     subDomainName: this.tenant.subDomainName,
      //     website: this.tenant.website,
      //     contactPerson: this.tenant.contactPerson,
      //     contactNo: this.tenant.contactNo,
      //     subscriptions: "basic",
      //     emailId: this.tenant.emailId,
      //     useSharedDb: true,
      //     configProfileID: 1
      //   }
      // };
      // this.$store.dispatch(this.addTenantDetails(data) )
      this.addTenant()
        .then(message => {
          notify(message);
          this.canContinue();
          this.$store.dispatch("loadTenants", null, { root: true });
        })
        .catch(notifyApiError);
    },
    close() {
      this.$router.push("tenant-management"); 
    },
    async getDataOnload() {
      this.$store.dispatch("loadClients");
    },
    canContinue() {
      this.$emit("can-continue", { value: true });
      
    },
    activate() {
      this.activateTenantDtls()
        .then(message => {
          notify(message);
          this.resetState();
          this.$store.dispatch("loadTenants", null, { root: true });
          // this.$router.push("/add-tenant");
        })
        .catch(notifyApiError);
    },
    onNext(){
      if(this.selected < 2){
        this.selected = this.selected + 1;
      }    
      else {
        this.selected = 0
      }
    },
    
  },

  computed: {
    ...mapFields(["onboarding.tenant", "onboarding.product"]),
    ...mapState(["products","clientId"]),
    getClient() {
      return this.$store.state.clients;
    },
  },
  props: ["readOnly"],
  mounted() {},
  created: function() {
    this.getDataOnload();
  }
};
</script>

<style>
label.required-field::after {
  content: "*";
  color: red;
  font-weight: bold;
}

.row {
  width: 99%;
  background-color: white;
  margin: 0 auto;
  padding: 30px 10px;
}

.buttons {
  /* width: 30%; */
  /* margin-left: 70%; */
  margin-top: 60px;
}

.save-button{
  width: 150px;
}

.rounded-border{
  border-radius: 5px;
  border-color: #0047b2;
}
.k-dropdown .k-dropdown-wrap, .k-dropdowntree .k-dropdown-wrap {
  border-radius: 5px;
  border-color: #0047b2;
}
/* .btn-info, .btn-default{
  margin-left: 20px;
} */
</style>